<template>
  <div
    class="fixed max-w-screen-xs mx-auto left-0 right-0 text-center h-14 flex items-center justify-center z-10 bg-premium"
  >
    <a
      href="#"
      data-test-id="btn_close"
      class="text-white absolute left-6 opacity-50"
      @click.prevent="emit('close')"
      ><i class="icon icon-close"></i
    ></a>
    <span class="text-tag text-white opacity-50">{{ t('activate') }}</span>
  </div>

  <div class="px-6" data-test-id="slider-ntf-purchase">
    <PremiumSlider :feature="feature" />
  </div>

  <div class="bg-white flex-grow px-6 rounded-t-2xl">
    <PremiumTimer v-if="!self.splitAuthorizationFee.isV3" />
    <div v-else class="mt-6"></div>

    <div v-if="packageSelected">
      <PremiumItem
        v-for="pkg in packageList"
        :key="pkg.id"
        v-model="packageSelected"
        :price-discount-fixed="self.getPriceDiscountFixed()"
        :pkg="pkg"
      />
    </div>

    <PremiumFooterVamp
      v-if="self.splitAuthorizationFee.isV3"
      :package-selected="packageSelected"
      :package-selected-price-formatted="self.packageSelectedPriceFormatted"
      :package-selected-price-next-formatted="self.packageSelectedPriceNextFormatted"
      :discount="getI18nDiscount()"
      :auth-fee-text="t('authorizationFee', { price: getFormattedCurrency(100) })"
      @show-membership="self.textPageModal.showModal('membership')"
    />
    <PremiumFooter
      v-else
      :package-selected="packageSelected"
      :package-selected-price-formatted="self.packageSelectedPriceFormatted"
      :package-selected-price-next-formatted="self.packageSelectedPriceNextFormatted"
      :discount="getI18nDiscount()"
      :auth-fee-text="
        self.splitAuthorizationFee.isV2
          ? t('authorizationFee', { price: getFormattedCurrency(100) })
          : ''
      "
      @show-membership="self.textPageModal.showModal('membership')"
    >
      <template v-if="self.splitAuthorizationFee.isV2" #security>
        <div class="flex justify-between">
          <div class="text-strongcaption text-dark-200 text-center my-2">
            <img class="w-4 h-4" src="./assets/img/ic_security.svg?url" alt="" /> {{ t('paySafe') }}
          </div>
          <div class="text-center">
            <img class="w-[138px]" src="./assets/img/pay-safe.png" width="500" alt="" />
          </div>
        </div>
      </template>
    </PremiumFooter>
  </div>

  <PurchaseContinue
    :is-autorefill-visible="false"
    btn-class="!bg-premium text-white"
    :root-class-name="
      self.splitAuthorizationFee.isV3
        ? 'fixed max-w-screen-xs w-full mx-auto left-1/2 bottom-0 -translate-x-1/2 z-10  px-6 pt-8 pb-4 bg-gradient-to-t from-white to-transparent from-70% to-100%'
        : 'fixed max-w-screen-xs w-full mx-auto left-1/2 bottom-0 -translate-x-1/2 z-10 bg-white px-6 pt-2 pb-4 border-t border-dark-500'
    "
    @select="emit('select')"
    @next="emit('next')"
  >
    <template #continue>
      {{
        t('getPremium', {
          discount: getI18nDiscount(),
        })
      }}
    </template>
  </PurchaseContinue>
</template>

<script lang="ts" setup>
import { onMounted, PropType } from 'vue';

import PremiumFooter from '@/components/ntf-modal/components/ntf-premium/components/premium-paywall/components/premium-footer/PremiumFooter.vue';
import PremiumFooterVamp from '@/components/ntf-modal/components/ntf-premium/components/premium-paywall/components/premium-footer-vamp/PremiumFooterVamp.vue';
import PremiumItem from '@/components/ntf-modal/components/ntf-premium/components/premium-paywall/components/premium-item/PremiumItem.vue';
import PremiumSlider from '@/components/ntf-modal/components/ntf-premium/components/premium-paywall/components/premium-slider/PremiumSlider.vue';
import { useSelf } from '@/components/ntf-modal/components/ntf-premium/components/premium-paywall/hooks/use-self/use-self';
import PremiumTimer from '@/components/ntf-modal/components/ntf-premium/components/premium-timer/PremiumTimer.vue';
import { SubscriptionFeature } from '@/components/subscription-promo-modal/helpers/subscription-promo-helper/type/type';
import { getFormattedCurrency } from '@/helpers/number';
import PurchaseContinue from '@/pages/payment/components/layout/components/purchase-continue/PurchaseContinue.vue';
import { PaymentStatePackagePremium } from '@/pages/payment/store/payment-state';
import { useI18n } from '@/services/i18n';

import { messages } from './i18n';

defineProps({
  feature: {
    type: String as PropType<SubscriptionFeature>,
    default: undefined,
  },
  packageList: {
    type: Array as PropType<PaymentStatePackagePremium[]>,
    required: true,
  },
});

const packageSelected = defineModel('packageSelected', {
  type: Object as PropType<PaymentStatePackagePremium>,
  required: true,
});

const emit = defineEmits(['next', 'close', 'select', 'update:packageSelected']);

const { t } = useI18n({ messages });

function getI18nDiscount() {
  return t('discount50');
}

const self = useSelf({ packageSelected });

self.init();

onMounted(() => {
  self.mount();
});
</script>

<script setup lang="ts"></script>
